var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArbitrumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470.287 514.251",
    enableBackground: "new 0 0 470.287 514.251",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logos_and_symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4_3_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "off_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "VER_3_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "VER_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "off_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_14_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D374B",
    d: "M291.134,237.469l35.654-60.5l96.103,149.684l0.046,28.727l-0.313-197.672 c-0.228-4.832-2.794-9.252-6.887-11.859L242.715,46.324c-4.045-1.99-9.18-1.967-13.22,0.063c-0.546,0.272-1.06,0.57-1.548,0.895 l-0.604,0.379L59.399,144.983l-0.651,0.296c-0.838,0.385-1.686,0.875-2.48,1.444c-3.185,2.283-5.299,5.66-5.983,9.448 c-0.103,0.574-0.179,1.158-0.214,1.749l0.264,161.083l89.515-138.745c11.271-18.397,35.825-24.323,58.62-24.001l26.753,0.706 L67.588,409.765l18.582,10.697L245.692,157.22l70.51-0.256L157.091,426.849l66.306,38.138l7.922,4.556 c3.351,1.362,7.302,1.431,10.681,0.21l175.453-101.678l-33.544,19.438L291.134,237.469z M304.736,433.395l-66.969-105.108 l40.881-69.371l87.952,138.628L304.736,433.395z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#28A0F0",
    points: "237.768,328.286 304.736,433.395 366.601,397.543 278.648,258.915  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A0F0",
    d: "M422.937,355.379l-0.046-28.727l-96.103-149.684l-35.654,60.5l92.774,150.043l33.544-19.438 c3.29-2.673,5.281-6.594,5.49-10.825L422.937,355.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.219,382.469l47.369,27.296l157.634-252.801l-26.753-0.706c-22.795-0.322-47.35,5.604-58.62,24.001 L50.334,319.004l-30.115,46.271V382.469z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "316.202,156.964 245.692,157.22 86.17,420.462 141.928,452.565 157.091,426.849  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96BEDC",
    d: "M452.65,156.601c-0.59-14.746-8.574-28.245-21.08-36.104L256.28,19.692 c-12.371-6.229-27.825-6.237-40.218-0.004c-1.465,0.739-170.465,98.752-170.465,98.752c-2.339,1.122-4.592,2.458-6.711,3.975 c-11.164,8.001-17.969,20.435-18.668,34.095v208.765l30.115-46.271L50.07,157.921c0.035-0.589,0.109-1.169,0.214-1.741 c0.681-3.79,2.797-7.171,5.983-9.456c0.795-0.569,172.682-100.064,173.228-100.337c4.04-2.029,9.175-2.053,13.22-0.063 l173.022,99.523c4.093,2.607,6.659,7.027,6.887,11.859v199.542c-0.209,4.231-1.882,8.152-5.172,10.825l-33.544,19.438 l-17.308,10.031l-61.864,35.852l-62.737,36.357c-3.379,1.221-7.33,1.152-10.681-0.21l-74.228-42.693l-15.163,25.717 l66.706,38.406c2.206,1.255,4.171,2.367,5.784,3.272c2.497,1.4,4.199,2.337,4.8,2.629c4.741,2.303,11.563,3.643,17.71,3.643 c5.636,0,11.132-1.035,16.332-3.072l182.225-105.531c10.459-8.104,16.612-20.325,17.166-33.564V156.601z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_13_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_6_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_15_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__7_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__3_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33__2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33__1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_10_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34__1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__6_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_11_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_12_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_9_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-1-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-2-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1_3_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1_1_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_7_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_8_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-1-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-2-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__4_"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrumLogo);
export default __webpack_public_path__ + "static/media/arbitrum-logo.8572fe020b7bba5d1f1e7f043d7e6dd3.svg";
export { ForwardRef as ReactComponent };